import constants from 'constants/index'

const statusLabel = (status) => {
  return constants.complaint.STATUS_LABEL[status]
}

export default statusLabel
